export const BILLING_INFO_VALIDATION_RULES = {
  recipient: {
    isRequiredTrim: {
      value: true,
    },
  },
  address: {
    isRequiredTrim: {
      value: true,
    },
  },
  city: {
    isRequiredTrim: {
      value: true,
    },
  },
  countryCode: {
    isRequiredTrim: {
      value: true,
    },
  },
  provinceCode: {
    isRequiredTrim: {
      value: true,
    },
  },
  postalCode: {
    isRequiredTrim: {
      value: true,
    },
    regex: {
      value: {
        pattern: /^[ABCEGHJKLMNPRSTVXY][0-9][ABCEGHJKLMNPRSTVWXYZ] ?[0-9][ABCEGHJKLMNPRSTVWXYZ][0-9]$/i,
        customMessageKey: "validation.customMessages.postalCodeRegex",
      },
    },
  },
  emailAddress: {
    regex: {
      value: {
        pattern: /^$|^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i,
        customMessageKey: "validation.emailRegex",
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/invoices/billingInfoValidationRules.js